import { Component, Input, OnInit } from '@angular/core';

interface SemaphoreObject {
  type?: string;
  text?: string;
}

@Component({
  selector: 'bn-account-detail-credit-card-multi',
  templateUrl: './account-detail-credit-card-multi.component.html',
})
export class BnAccountDetailCreditCardMultiComponent implements OnInit {
  @Input() product: any;
  @Input() productNumberFormat: any;
  @Input() hostRef: any;
  localCurrency = 'DOP';
  foreignCurrency = 'USD';
  overdueTooltipText = $localize`:@@product-details.overdueLabel:Statement payment overdue`;
  successTooltipText = $localize`:@@product-details.successLabel:Statement paid`;
  greyTooltipText = $localize`:@@product-details.greyLabel:Statement payment pending`;
  dopSemaphore: SemaphoreObject = {};
  usdSemaphore: SemaphoreObject = {};

  accountDetailTitle = $localize`:@@product-details.h2.accountDetails:Account Detail`;
  creditTitle = $localize`:@@product-details.h2.credit:Credit`;
  otherInfoTitle = $localize`:@@product-details.h2.otherInfo:Other information`;
  statementsTitle = $localize`:@@product-details.h2.statements:Statements`;

  ngOnInit(): void {
    this.product?.additions?.minimumPmtSemaphoreDOP?.toLowerCase();
    this.dopSemaphore = this.setTooltips(this.product?.additions?.minimumPmtSemaphoreDOP?.toLowerCase());
    this.usdSemaphore = this.setTooltips(this.product?.additions?.minimumPmtSemaphoreUSD?.toLowerCase());
  }

  setTooltips(semaphoreValue: string): SemaphoreObject {
    switch (semaphoreValue) {
      case 'green':
        return {
          type: 'success',
          text: this.successTooltipText,
        };
      case 'red':
        return {
          type: 'danger',
          text: this.overdueTooltipText,
        };
      case 'gray':
        return {
          type: 'grey',
          text: this.greyTooltipText,
        };
      default:
        return {};
    }
  }
}
